<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item active>{{$t('historial.cursos.title')}}</b-breadcrumb-item>
        </b-breadcrumb>
        <div class="card">
            <div class="card-body">
                <h4 class="sub-title"><span>{{$t('historial.cursos.sub-title')}}</span></h4>
                <b-container fluid style="padding: 0px !important;">
                    <div class="d-flex">
                        <div class="mr-3">
                            <b-form-group class="mr-2" :label="$t('historial.cursos.filter.1.label')" id="cursosHistorialMultiSelect">
                                <multiselect style="width: 350px;"
                                    multiselect v-model="value" :options="optionCourses" :multiple="true"
                                    :internal-search="false" :clear-on-select="false" :close-on-select="false"
                                    :loading="isLoading"
                                    @select="selectAll"
                                        @input="onChange"
                                    @remove="deselect"
                                    :limit="countLimit" :limit-text="limitText"
                                    :placeholder="$t('historial.cursos.filter.1.placeholder')" label="name" track-by="id" :preselect-first="false">
                                    <template slot="clear" slot-scope="props">
                                        <div class="multiselect__clear" v-if="value.length" @mousedown.prevent.stop="clearAll(props.search)">
                                            <span class="material-icons">
                                                close
                                            </span>
                                        </div>
                                    </template>
                                </multiselect>
                            <!--
                                
                                :hide-selected="true"
                                 <CustomSelect
                                    :options="optionsHistoryCourse"
                                    :default="$t('filter.text')"
                                />
                                <b-form-select class="w-100"
                                v-model="selectedHistoryCourse" 
                                :options="optionsHistoryCourse"
                                >
                                    <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                                </b-form-select> -->
                            </b-form-group>
                        </div>
                        <div class="mr-3">
                            
                            <b-form-group class="mr-2"  :label="$t('historial.cursos.filter.2')">
                                <CustomSelect style="width: 243px;"
                                    @input="idValueSelectHistoryStateAsigmments"
                                    :options="optionsHistoryState"
                                    value="id"
                                    label="descripcion" 
                                    :default="$t('filter.text')"
                                     @change="getListCourses()"
                                />
                                <!-- <b-form-select class="w-100"
                                v-model="selectedHistoryState" 
                                :options="optionsHistoryState"
                                >
                                    <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                                </b-form-select> -->
                            </b-form-group>
                        </div>
                        <div>
                                <b-form-group class="mr-2"  :label="this.$t('historial.cursos.filter.3')">
                        <CustomSelect style="width: 243px;"
                              @input="idValueSelectHistoryCertificateAsigmments"
                            :options="optionsHistoryCertificate"
                            value="id"
                            label="descripcion" 
                            :default="$t('filter.text')"
                            @change="getListCourses()"
                        />
                        <!-- <b-form-select class="w-100"
                        v-model="selectedHistoryCertificate" 
                        :options="optionsHistoryCertificate"
                        >
                            <template #first><b-form-select-option :value="null">Todos</b-form-select-option> </template>
                        </b-form-select> -->
                    </b-form-group>

                        </div>
                    </div>
                  
                </b-container>
                <!--<b-form inline style="margin-bottom: 18px;">
                 
                
                </b-form>-->
                <b-table hover :items="itemsAssignments"  :busy="isBusy"  :show-empty="true" 
                :fields="fielAssignments" id="tableStudentHistory" :empty-text="$t('reusables.empty-text')">
                    	<template #table-busy>
						<div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> {{$t('ClassRequest.Loading')}}...</strong>
                                        </div>
					</template>
                    <template #cell(state)="data">
                        <div>
                            <p :style="{color:data.value.color}">{{data.value.name}}</p>
                        </div>
                    </template>
                    <template #cell(certificate)="data">
                        <div v-if="data.item.flagApply">
                         
                            <span v-if="data.value.id==1">
                                 <a class="link noBorder mr-2" @click="DonwloadFile(data.value.link)">
                                    <icon name="certificate" />
                                    <!-- <img src="@/assets/icons/icon-certificate.svg" class="svg"> -->
                                </a>
                            </span>
                            <span v-if="data.value.id==2">
                                  -
                            </span>
                            <span v-if="data.value.id==3" style="color:#B7B8BD">
                                N/A
                            </span>

                           
                        </div>
                        <p v-else style="color:#B7B8BD">N/A</p>
                        <!-- <p v-else-if="data.item.certificate===null" style="color:#B7B8BD">{{data.item.certificate}}</p> -->
                       
                    </template>
                    <template #cell(evaluations)="data">
                        <div v-if="data.item.flagEdited===true">
                            <a @click="linkEvaluation(data.item)" class="link noBorder">
                                <icon name="valid-doc" />
                                <!-- <img src="@/assets/icons/icon-valid-doc.svg" class="svg"> -->
                            </a>
                          
                        </div>
                        <p v-else>-</p>
                    </template>
                    <template #cell(return)="data">
                        <div v-if="!data.item.flagGroup && (data.item.state.value===3 || data.item.state.value===4)">
                             <router-link class="btn btn-primary" to="/cursos">
                          {{$t('historial.cursos.button.1')}}
                        </router-link>
                          
                        </div>
                    </template>
                </b-table>
                <div class="overflow-auto content-pagination">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        aria-controls="table-evaluation"
                    ></b-pagination>
                    {{currentPage}}-{{perPage}} / {{totalRows > 0 ?  totalRows : totalRows-1}}   {{$t('ClassRequest.text.3')}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import CustomSelect from "@/components/form/select";
import * as tools from '@/assets/js/tools.js';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import * as Constants from "@/assets/js/appConstants";
import { getNextClassDate, getCourseColors, getCourseStateName } from '@/assets/js/util.js';
const lang = localStorage.getItem('lang') || 'es';

  export default {
    components:{
        CustomSelect ,
        'multiselect': Multiselect
  
    },
    data() {
      return {
        isBusy : false,
        currentPage: 1,
        perPage : 10,
        totalRows:  0,
        isLoading:false,
        value: [],
        countLimit : 3,
        countAllCourses : 6,
        itemSelect :null,
        itemDeselect :null,
        optionCourses: [],
        selectedHistoryCourse: null,
        optionsHistoryCourse: [
          { value: null, text: this.$t('historial.cursos.please-select-option') },

        ],
        selectedHistoryState: null,
        optionsHistoryState: [],
        selectedHistoryCertificate: null,
        optionsHistoryCertificate: [],
        fielAssignments:[
            {key:'course' , label: this.$t('historial.cursos.table-th.1')},
            {key:'class' , label: this.$t('historial.cursos.table-th.2')},
            {key:'state' , label: this.$t('historial.cursos.table-th.3')},
            {key:'qualification' , label: this.$t('historial.cursos.table-th.4')},
            {key:'certificate' , label: this.$t('historial.cursos.table-th.5')},
            {key:'evaluations' , label: this.$t('historial.cursos.table-th.6'),thStyle:{width:"12%"}},
            {key:'return' , label:'',thStyle:{width:"18%"}}
            ],
        itemsAssignments: [],
        lang: lang
        
      }
    },
    created(){
        this.getListFilters();
        this.getListCourses();
    },
    mounted(){
        //importante para los iconos, arriba esta la importación ----------------
        this.$nextTick(function () {
            tools.imgToSvg()
        })
    },
     watch: {
            currentPage: {
                handler: function(value) {
                         this.getListCourses();
                }
            },
        
	    },
    methods:{
        linkEvaluation(item){
            const data = {
                id: item.id, 
                groupPlanId: item.groupPlanId 
            };

            this.$router.push({name: 'student/evaluaciones', params: data}).catch(err => {});
        },
        onChange(event){
         
            if(this.itemSelect){
                if(this.itemSelect.id == 0){
                    this.value = [] 
                    for (let item of this.optionCourses) {
                        if (parseInt(item.id) > 0) {
                            this.value.push(item); 
                        } 
                    }   
                    this.value.push(  { name: this.$t('reusables.select-all'), id: 0 })
                }else{
                    if(this.countAllCourses == this.value.length){
                        this.value.push(
                             { name: this.$t('reusables.select-all'), id: 0 }
                        )
                    }
                }
            }

            if(this.itemDeselect ){
                if(this.itemDeselect.id == 0){
                     this.value = []
                }else{  
                    let indexAll = null;
                    this.value.filter(function(currentValue,index,arr){
                     
                        if(currentValue.id == 0){
                            indexAll = index
                        }
                    });
                  
                    if(indexAll != null){
                        this.value.splice(indexAll, 1);
                    }
                    
                            

                   
                }
            }

                 this.getListCourses();
                  
        },
        deselect(option){
            this.itemSelect =null;
            this.itemDeselect = option
        },
        selectAll(option){
            this.itemDeselect = null;
            this.itemSelect = option
        },
        clearAll () {
            this.value = []
        },
        limitText (count) {
            return this.$t('historial.cursos.others-cuorses',{COUNT: count})
        },
        getListCourses(){
            this.isBusy = true;
            
            let valueCourses = null;
            if(this.value.length>0){
                let indexZero = this.value.filter(function(currentValue,index,arr){
                    return currentValue.id == 0
                    
                });
                    if(indexZero.length>0){
                    valueCourses = null;
                }else{
                    valueCourses = this.value.map(element =>(element.id))
                }
            }
            this.itemsAssignments  =[];
            let format_day = "DD/MM/YYYY";
            let body = {
                PersonsStudentId :this.$store.state.user.personStudentId, //235,
                ListSubjectLevelsIds : valueCourses,
                StateId: this.selectedHistoryState,
                TypeCertificate : this.selectedHistoryCertificate,
                //PersonTeacherId:null,
                Page : this.currentPage,
                Size : this.perPage

            }
             baseInstanceAxios
                .post(`${this.apiURL}/resources/PersonsAssignmentsEvaluations/ListPersonsSubjectsHistory`,body)
                .then(response => {
                 
                   if(response.data.list){
                        response.data.list.forEach(element => {
                            console.log("element : ",element)
                            let json = {
                                id : element.id,
                                flagGroup : element.flagGroup,
                                course : element.subjectName,
                                class : element.lastDateSchedule ? getNextClassDate(element.lastDateSchedule, this.$store.state.user.timeZoneName, this.$moment, format_day) : '-',
                                flagApply : element.flagApply,
                                flagEdited : element.flagEdited,
                                groupPlanId : element.groupPlanId,
                                state : {
                                    value : parseInt(element.subjectStateValue),
                                    name :  this.lang == "es" ? element.subjectStateName : getCourseStateName(parseInt(element.subjectStateValue)),
                                    color : getCourseColors(parseInt(element.subjectStateValue))
                                },
                                qualification: element.score ? element.strScore : '-',
                                certificate : {
                                    id : element.certificateId,
                                    link : element.fileCertificate,
                                },
                                evaluations : '-',
                                return : true


                            }

                            this.itemsAssignments.push(json);
                        });
                     
                       
                   }

                    this.totalRows = response.data.rows;
                    
                 
                     this.isBusy = false;
                      this.$nextTick(function () {
                        tools.imgToSvg()
                    })
                });
        },
 
        idValueSelectHistoryStateAsigmments(event){
            this.selectedHistoryState = event;
        },
         idValueSelectHistoryCertificateAsigmments(event){
            this.selectedHistoryCertificate = event;
        },
        DonwloadFile(fileName){
            let headers = { responseType: "blob"};

            baseInstanceAxios
            .get(`${this.apiURL}/Resources/PersonsAssignmentsEvaluations/DownloadFileCertificate?nameFile=${fileName}`, headers)
            .then((response) => {
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(new Blob([response.data]));
                link.setAttribute('download', `${fileName}`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch(() =>{});
        },
        getListFilters(){
           
            let params = {
                idPersonStudent: this.$store.state.user.personStudentId
            };

            this.optionCourses=[
              { name: this.$t('reusables.select-all'), id: 0 }
                ],
           
            baseInstanceAxios
                .get(`${this.apiURL}/resources/Subjects/ListSubjectsLevelHistoryByPersonStudent`, {params})
                .then(response => {
                 
                   if(response.data.entity){
                       let arrayCourses = response.data.entity.listSubjects

                       arrayCourses.forEach(element => {
                           this.optionCourses.push(
                                    {
                                id : element.id,
                                name : element.name
                            }
                           )
                       });
                    
                        if(arrayCourses.length == 0){
                            this.countLimit = 0
                            this.optionCourses = [];
                        }

                        if(arrayCourses.length == 1){
                            this.countLimit = 1
                        }

                        if(arrayCourses.length == 2){
                            this.countLimit = 2
                        }

                     this.countAllCourses = arrayCourses.length;

                      this.optionsHistoryState =  response.data.entity.listStatesSubjects.map(element =>(
                          {
                              id : element.id,
                              descripcion : element.descripcion
                          }
                      ))

                       this.optionsHistoryCertificate =  response.data.entity.listCertificates.map(element =>(
                          {
                              id : element.id,
                              descripcion : element.descripcion
                          }
                      ))
                   }
                });
        }
    }
  }
</script>